import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const inputVariants = cva(
  'flex w-full rounded-md border border-border bg-card transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        default: 'h-9 px-3 text-base md:text-sm max-w-[450px]',
        sm: 'h-8 px-2 text-xs',
        lg: 'h-10 px-4 text-base max-w-[450px]',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export interface InputProps
  extends Omit<React.ComponentProps<'input'>, 'size'>, VariantProps<typeof inputVariants> {}

function Input({ className, size, type, ref, ...props }: InputProps) {
  return (
    <input type={type} className={cn(inputVariants({ size, className }))} ref={ref} {...props} />
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export { Input, inputVariants }
